import api from "./api";
import { mapFlexDayDto } from "../dto/FlexDayDTO";

export const getFlexDayEntries = async ({ role, userId }) => {
    try {
        const url = `/FlexDay/user/${userId}`;
        const res =
            role === 'admin' || role === 'super_admin'
                ? await api.get('/FlexDay')
                : await api.get(url);
        return res.data.map(mapFlexDayDto);
    } catch (err) {
        console.error("Error getting Gleitzeit:", err);
        throw err;
    }
};

export const createFlexDay = async ({ user_id, start_date, end_date, number_days }) => {
    try {
        const res = await api.post('/FlexDay', { user_id, start_date, end_date, number_days });
        return res.data;
    } catch (err) {
        console.error("Error creating Gleitzeit:", err);
        throw err;
    }
};

export const updateFlexDay = async (id, { start_date, end_date, number_days }) => {
    try {
        const res = await api.patch(`/FlexDay/${id}`, { start_date, end_date, number_days });
        return res.data;
    } catch (err) {
        console.error("Error updating Gleitzeit:", err);
        throw err;
    }
};

export const deleteFlexDay = async (id) => {
    try {
        const res = await api.delete(`/FlexDay/${id}`);
        return res.data;
    } catch (err) {
        console.error("Error deleting Gleitzeit:", err);
        throw err;
    }
};

export const approveFlexDay = async (id) => {
    try {
        const res = await api.post(`/FlexDay/${id}/approve`);
        return res.data;
    } catch (err) {
        console.error("Error approving Gleitzeit:", err);
        throw err;
    }
};

export const rejectFlexDay = async (id, reason = null) => {
    try {
        const res = await api.post(`/FlexDay/${id}/reject`, { reason });
        return res.data;
    } catch (err) {
        console.error("Error rejecting Gleitzeit:", err);
        throw err;
    }
};

export const getPendingFlexDayCount = async () => {
    try {
        const res = await api.get('/FlexDay/pending-count');
        return res.data?.count ?? 0;
    } catch {
        return 0;
    }
};
